export const FLOW_NAME = "notebook-analysis";

export const NOTEBOOK_NAME = "NOTEBOOK_NAME";
export const EXPERIMENT_NAME = "EXPERIMENT_NAME";
export const EXPERIMENT_KEY = "EXPERIMENT_KEY";
export const SECTION_NAME = "SectionName";
export const SECTION_NICK_NAME = "SectionNickName";

export const LABELS = [NOTEBOOK_NAME, EXPERIMENT_KEY, EXPERIMENT_NAME];

export const DISSOLUTION_MEAN = "Dissolution Mean";
export const DISSOLUTION_RSD = "Dissolution %RSD";
export const COMPONENT_NAME = "Component_Name";
export const DISSO_MEDIUM = "Disso_Medium";
export const DISSO_TIME = "time";

export const DISSOLUTION_INDEXERS = [
  NOTEBOOK_NAME,
  EXPERIMENT_KEY,
  "SectionKey",
  "ApparatusType",
  "Bath",
  COMPONENT_NAME,
  DISSO_MEDIUM,
  "RPM",
  "TemplateName",
];

export default {
  FLOW_NAME,
  LABELS,
};
